import { MappedVacationsRequest } from 'src/components/Timeoff/widgets/RequestsWidget/models/RequestWidget.interface';
import { TableRowEnum } from 'src/components/Timeoff/widgets/RequestsWidget/RequestsWidget';
import { TableBodyRow, TableBody } from './styles/AXSTableBody.styled';
import {
  generateReactKey,
  KeyRoots,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';

interface AXSTableBodyProps {
  requests: MappedVacationsRequest[];
  tableRow: TableRowEnum[];
  handleRequestDetails: (requestId: string) => void;
}

export const AXSTableBody = ({
  requests,
  tableRow,
  handleRequestDetails,
}: AXSTableBodyProps) => {
  return (
    <TableBody>
      {requests.map((item) => {
        return (
          <TableBodyRow
            key={item.new_axsvacationrequestid}
            onClick={() => handleRequestDetails(item.new_axsvacationrequestid)}
          >
            {tableRow.map((value, index) => {
              return (
                <td key={generateReactKey(KeyRoots.TIME_OFF_TABLE_ROW, index)}>
                  {item[value]}
                </td>
              );
            })}
          </TableBodyRow>
        );
      })}
    </TableBody>
  );
};
